import React from 'react';
import PropTypes from 'prop-types';
import {withStyles} from 'material-ui/styles';
import classNames from 'classnames';
import ExpansionPanel, {
    ExpansionPanelActions,
    ExpansionPanelDetails,
    ExpansionPanelSummary,
} from 'material-ui/ExpansionPanel';
import Typography from 'material-ui/Typography';
import ExpandMoreIcon from 'material-ui-icons/ExpandMore';
import Chip from 'material-ui/Chip';
import Button from 'material-ui/Button';
import Divider from 'material-ui/Divider';

const styles = theme => ({
    root: {
        width: '100%',
    },
    heading: {
        fontSize: theme.typography.pxToRem(15),
    },
    secondaryHeading: {
        fontSize: theme.typography.pxToRem(15),
        color: theme.palette.text.secondary,
    },
    icon: {
        verticalAlign: 'bottom',
        height: 20,
        width: 20,
    },
    details: {
        alignItems: 'center',
    },
    column: {
        flexBasis: '33.3%',
    },
    helper: {
        borderLeft: `2px solid ${theme.palette.text.lightDivider}`,
        padding: `${theme.spacing.unit}px ${theme.spacing.unit * 2}px`,
    },
    link: {
        color: theme.palette.primary[500],
        textDecoration: 'none',
        '&:hover': {
            textDecoration: 'underline',
        },
    },
});

function DetailedExpansionPanel(props) {
    const {classes} = props;
    return (
        <div className={classes.root}>
            <ExpansionPanel defaultExpanded>
                <ExpansionPanelSummary expandIcon={<ExpandMoreIcon/>}>
                    <div className={classes.column}>
                        <Typography className={classes.heading}>Location</Typography>
                    </div>
                    <div className={classes.column}>
                        <Typography className={classes.secondaryHeading}>Select trip destination</Typography>
                    </div>
                </ExpansionPanelSummary>
                <ExpansionPanelDetails className={classes.details}>
                    <div className={classes.column}/>
                    <div className={classes.column}>
                        <Chip label="Barbados" className={classes.chip} onDelete={() => {
                        }}/>
                    </div>
                    <div className={classNames(classes.column, classes.helper)}>
                        <Typography type="caption">
                            Select your destination of choice<br/>
                            <a href="javascript:void(0)" className={classes.link}>
                                Learn more
                            </a>
                        </Typography>
                    </div>
                </ExpansionPanelDetails>
                <Divider/>
                <ExpansionPanelActions>
                    <Button dense>Cancel</Button>
                    <Button dense color="primary">
                        Save
                    </Button>
                </ExpansionPanelActions>
            </ExpansionPanel>
        </div>
    );
}

DetailedExpansionPanel.propTypes = {
    classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(DetailedExpansionPanel);


// WEBPACK FOOTER //
// ./app/routes/components/routes/expansionPanel/detailed/index.js